import script from "./billing-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./billing-settings.vue?vue&type=script&setup=true&lang=js"

import "./billing-settings.vue?vue&type=style&index=0&id=d49ae1ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d49ae1ec"]])

export default __exports__